<template>
  <div class="overview-map">
    <div class="overview-map__header" v-if="type === 'electoral'">
      <template v-if="isLayoutMobile"> Who will win the presidential election? </template>
      <template v-else> Presidential Election Winner? </template>
    </div>
    <div class="overview-map__header" v-else>Control of the Senate</div>
    <div class="overview-map__content">
      <template v-if="!isComponentReady">
        <div class="content-loader">
          <div class="content-loader-item" v-for="index in dummyComponents">
            <overview-map-loader></overview-map-loader>
          </div>
        </div>
      </template>
      <template v-else>
        <overview-map-contract
          class="overview-map__content-contract"
          :type="type"
          v-for="item in items"
          :key="item.contractId"
          :item="item"
        >
        </overview-map-contract>
      </template>
    </div>
  </div>
</template>
<script src="./overview-map.js"></script>
<style src="./overview-map.scss" lang="scss"></style>
